import React from 'react';
import PropTypes from 'prop-types';

import { Wheel } from '../../Wheel';
import { Avatar } from './styles';

function RouletteLogo({ data, styles }) {
  const dataItems = data.items.map((item) => ({
    option: item.text,
    style: {
      backgroundColor: item.background,
      fontSize: item.fontSize,
      textColor: item.color,
    },
  }));

  return (
    <Wheel
      mustStartSpinning={data.mustSpin}
      prizeNumber={data.prizeNumber}
      data={dataItems}
      outerBorderColor={styles?.container?.background}
      outerBorderWidth={10}
      innerRadius={29}
      innerBorderColor={styles?.container?.background}
      innerBorderWidth={8}
      radiusLineColor={styles?.container?.background}
      radiusLineWidth={8}
      selectorColor={styles?.selector?.background}
      textDistance={65}
    >
      {data.avatar && <Avatar src={data.avatar} alt="roulette-static" />}
    </Wheel>
  );
}

RouletteLogo.propTypes = {
  data: PropTypes.shape({
    avatar: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object),
    mustSpin: PropTypes.bool,
    prizeNumber: PropTypes.number,
  }),
  styles: PropTypes.shape({
    container: PropTypes.shape({
      background: PropTypes.string,
    }),
    selector: PropTypes.shape({
      background: PropTypes.string,
    }),
  }),
};

RouletteLogo.defaultProps = {
  data: {
    avatar:
      'https://overlayon.s3.eu-west-3.amazonaws.com/overlayon.png',
    items: [],
    mustSpin: false,
    prizeNumber: 0,
  },
  styles: {
    container: {
      background: '#eeeeee',
    },
    selector: {
      background: '#e24a2b',
    },
  },
};

export default RouletteLogo;
